export enum GiftType {
  GIFT_ITEMS = "gift_items",
  EXPERIENCES = "experiences",
  GOURMET_MEALS = "gourmet_meals",
  COFFEE_BEVARAGES = "coffee_bevarages",
  GIFT_CARD = "gift_card",
}

const giftTypeOptions = [
  {
    value: GiftType.GIFT_ITEMS,
    label: "Gift Box"
  },
  // {
  //   value: GiftType.GOURMET_MEALS,
  //   label: "Gourmet Meals",
  // },
  // {
  //   value: GiftType.EXPERIENCES,
  //   label: "Experiences",
  // },
  // {
  //   value: GiftType.COFFEE_BEVARAGES,
  //   label: "Coffee & Beverages",
  // },
  {
    value: GiftType.GIFT_CARD,
    label: "Gift Card",
  },
];
export { giftTypeOptions };
